// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcs_a bib_ke","ListItemIcon--empty":"bcs_b bib_fl"};